'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@emotion/react');
var InternalRadio_web = require('../../internal/InternalRadio/InternalRadio.web.cjs');
require('../../internal/InternalSkeleton/InternalSkeleton.web.styles.cjs');
require('../Typography/Typography.web.cjs');
require('aviary-tokens');
require('@remix-run/react');
require('react-router-dom');
var Radio_web_styles = require('./Radio.web.styles.cjs');

/**
 * A radio component for selecting a single option from a list.
 *
 * {@link https://aviary.supernova-docs.io/latest/components/template/overview-XyAkNT4q | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Radio/Radio.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Radio = ({ children, alignment = "center", customCss, ...internalProps })=>{
    const labelStyles = alignment === "top" && Radio_web_styles.topAlignment;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalRadio_web.InternalRadio, {
        ...internalProps,
        css: customCss,
        labelStyle: labelStyles,
        children: children
    });
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.web.cjs.map
